import React, { useId, SelectHTMLAttributes, forwardRef } from 'react';

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  hint?: string;
  required?: boolean;
  options: { label: string; value: string | number }[];
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ label, error, hint, required, options, className = '', ...props }, ref) => {
    const autoId = useId();
    const id = props.id ?? autoId;
    return (
      <div className={`fc ${error ? 'err' : ''} ${className}`.trim()}>
        {label && (
          <label htmlFor={id}>
            {label}
            {required && <span className="req">*</span>}
          </label>
        )}
        <select ref={ref} {...props} id={id}>
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        {error && <div className="msg">{error}</div>}
        {hint && !error && <div className="cap">{hint}</div>}
      </div>
    );
  }
);

Select.displayName = 'Select';
